import React, { useState } from 'react';
import styled from 'styled-components';

import { intelligenceScrollbar } from 'containers/Intelligence/theme/scrollbar';

import ConfigStudio from '../configStudio/ConfigStudio';
import { HISTORY_FIXTURE } from '../history/historyFixture';
import CampaignWizard from '../wizard/CampaignWizard';
import { WizardOverlayContext } from '../wizard/kit/WizardModal';
import { CampaignWizardSubmit, WizardHandoff } from '../wizard/wizardSubmission';
import { PageChatComposer } from './OrbitPageChat';

const Area = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
`;

// The wizard's modals mount here, so their scrim covers the main column only (6778:22346).
const Stage = styled.div`
  position: relative;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
`;

// Not the thread's scroll marker: the transcript must never scroll the wizard. Panels start 62
// under the top bar (6778:18418 at y 144).
const Scroller = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  padding: 62px 24px 32px;
  overflow-y: auto;
  ${intelligenceScrollbar('y')}
`;

interface IOrbitPageWizardViewProps {
  /** The Create a Campaign wizard alone, or inside the Config Studio's Config / History tabs. */
  variant: 'campaign' | 'config';
  onSubmit: CampaignWizardSubmit;
  onExit: () => void;
  onHandoff: WizardHandoff;
}

/** The standalone wizard in place of the thread, over the same composer bar. */
const OrbitPageWizardView: React.FC<IOrbitPageWizardViewProps> = ({
  variant,
  onSubmit,
  onExit,
  onHandoff
}) => {
  const [stage, setStage] = useState<HTMLDivElement | null>(null);
  return (
    <Area data-testid="orbit-page-wizard">
      <Stage ref={setStage}>
        <WizardOverlayContext.Provider value={stage}>
          <Scroller data-testid="orbit-page-wizard-scroll">
            {variant === 'config' ? (
              <ConfigStudio
                submitCampaign={onSubmit}
                onHandoff={onHandoff}
                historyRows={HISTORY_FIXTURE}
                onExit={onExit}
                onDuplicate={() => undefined}
              />
            ) : (
              <CampaignWizard onSubmit={onSubmit} onExit={onExit} onHandoff={onHandoff} />
            )}
          </Scroller>
        </WizardOverlayContext.Provider>
      </Stage>
      <PageChatComposer />
    </Area>
  );
};

export default OrbitPageWizardView;
